import React from "react";
import Dropzone from "react-dropzone";
import { Checkbox, RaisedButton, CircularProgress, FlatButton } from "material-ui";
import { Table } from "reactable";

import connectToStores from "alt-utils/lib/connectToStores";
import BulkImportActions from "../actions/BulkImportActions";
import BulkImportStore from "../stores/BulkImportStore";
import UserStore from "../stores/UserStore";

import InfoNotice from "./partials/info-notice.jsx";

import CheckCircleIcon from "material-ui/svg-icons/action/check-circle";
import ErrorIcon from "material-ui/svg-icons/alert/error";

import config from "../config";
import InjectedSelect from "./partials/injected-select.jsx";
import Label from "./partials/label.jsx";
import QuillEditor from "./partials/quill-editor.jsx";
import LinkLike from "./partials/link-like.jsx";
import userStore from "../stores/UserStore";
import BulkImportUtil from "../utils/BulkImportUtil";
import { formatBasedOnQuantity } from "../util";
import GlobalNotificationActions from "../actions/GlobalNotificationActions";

class BulkImportPasses extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPassBucket: null,
      extraMessage: "",
      csvFile: null,
      noEmail: false,
      userReadyToImport: false,
      currentImportStatus: {},
      isMembership: null,
    };

    this.reset = this.reset.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.import = this.import.bind(this);
    this._makeImportMessage = this._makeImportMessage.bind(this);
    this.onErrorCsvClick = this.onErrorCsvClick.bind(this);
  }

  static getStores() {
    return [BulkImportStore, UserStore];
  }

  static getPropsFromStores() {
    return BulkImportStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      progressContainer: {
        margin: "0 auto",
        textAlign: "center",
        padding: 10
      },
      restartLink: {
        textDecoration: "underline",
        cursor: "pointer",
        paddingLeft: 2
      },
      icon: {
        width: 80,
        height: "auto",
        color: "rgb(2, 136, 209)"
      },
      message: {
        marginTop: 10
      },
      dropzone: {
        lineHeight: "1.25",
        padding: 10,
        border: "1px dashed #ccc",
        cursor: "pointer"
      },
      actions: {
        marginTop: 10
      },
      previewExtraMessage: {
        padding: 20,
        border: "1px dashed #ccc"
      },
      section: {
        marginTop: 20
      }
    };
  }

  componentWillMount() {
    this.reset();
  }

  componentDidMount() {
    const isMembership = this.props.location.pathname.includes("membership");
    this.setState({ isMembership: isMembership })
  }

  componentWillUnmount() {
    clearInterval(this._statusChecker);
  }

  componentWillReceiveProps(props) {
    if (
      props.importOrder &&
      this.state.userReadyToImport &&
      !this._statusChecker
    ) {
      // Start fetching order status
      this._statusChecker = setInterval(() => {
        fetch(this._makeFetchUrl(props.importOrder))
          .then(r => r.json())
          .then(currentImportStatus => {
            this.setState({ currentImportStatus });
            if (currentImportStatus.finished) {
              clearInterval(this._statusChecker);
              this._statusChecker = null;
            }
          });
      }, 2000);
    }
  }

  _makeFetchUrl(id) {
    return `${config.endpoint
      }bulk_import/passes/status?id=${id}&${UserStore.makeApiKeyQueryString()}`;
  }

  _makeImportMessage() {
    let { completed, succeeded, failed, total, error_message } = this.state.currentImportStatus;
    const singular = this.state.isMembership ? "membership" : "pass"
    const plural = this.state.isMembership ? "memberships" : "passes"

    const errors = error_message ? error_message.split("; ") : []

    let nonCompleteText = (<text>Warming up... getting ready to import...</text>)

    let completeElement = (
      <div style={{ display: "flex", flexDirection: "column", alignContent: "center", alignItems: "center" }}>
        <text>
          {`${succeeded || 0} / ${total || 0} ${formatBasedOnQuantity(total || 0, singular, plural)} imported ${completed === total ? "successfully!" : "so far..."}`}
        </text>
        {errors.length > 0 && <text style={{ marginTop: 8 }}>There were {failed} errors in this import:</text>}
        {errors.length > 0 && (
          <div style={{ display: "flex", flexDirection: "column", marginTop: 4, marginBottom: 8, textAlign: "left" }}>
            {errors.map((error, index) => (
              <text>
                {`${index + 1}.`} {error}
              </text>
            ))
            }
          </div>
        )}
      </div>
    )


    return !completed
      ? nonCompleteText
      : completeElement;
  }

  async onErrorCsvClick() {
    const { apiKey } = userStore.getState()
    const { previewData } = this.props

    //Since we're potentially passing a big object to make this CSV, let's pass it in the JSON body, which sadly means we can't just link them to the API call as usual
    const csv = await BulkImportUtil.fetchPassErrorsCsv(apiKey, previewData.errors_encountered, this.state.selectedPassBucket.id)

    const href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;

    const link = document.createElement("a");
    link.href = href;
    link.download = this.state.isMembership ? "bulk-import-memberships-errors.csv" : "bulk-import-passes-errors.csv";
    link.click()
    link.remove();
  }

  reset() {
    this.setState({
      csvFile: null,
      userReadyToImport: false
    });
    BulkImportActions.reset.defer();
  }

  onDrop(files, rejected) {
    if (rejected.length > 0) {
      GlobalNotificationActions.notify("Only .xlsx, .xls, and .csv files are accepted")

      return;
    }

    if (!files.length) {
      return;
    }
    this.setState({
      csvFile: files[0]
    });
  }

  import() {
    BulkImportActions.importPasses({
      eventBucket: this.props.params.eventBucketId,
      passBucket: this.state.selectedPassBucket.id,
      extraMessage: this.state.extraMessage,
      csvFile: this.state.csvFile,
      preview: !this.state.userReadyToImport,
      noEmail: this.state.noEmail,
      isMembership: this.state.isMembership
    });
    window.scrollTo(0, 0);
  }

  _makeCsvLink() {
    return config.endpoint + "bulk_import/example/passes";
  }

  _makeCsvLinkForMemberships() {
    return config.endpoint + "bulk_import/example/memberships";
  }

  _makeTable(passBucket, passes, options = {}) {
    const { isErrorTable, style } = options;

    let fieldColumns = passBucket.supplementary_data
      ? passBucket.supplementary_data.map(d => {
        return { key: d.key, label: d.label };
      })
      : [];

    let selectedColumns = !isErrorTable ?
      [
        { key: "name", label: "Name" },
        { key: "email", label: "Email" }
      ]
        .concat(
          passBucket.recurrence_enabled
            ? [{ key: "renewal_date", label: "Renewal date" }]
            : []
        )
        .concat(fieldColumns) : [
          { key: "row_number", label: "Row Number" },
          { key: "email", label: "Email" },
          { key: "error", label: "Error Message" },
          { key: "name", label: "Name" },
        ]
          .concat(fieldColumns)
          .concat(
            passBucket.recurrence_enabled ? [{ key: "renewal_date", label: "Renewal date" }] : []
          )

    return (
      <Table
        className={"bordered striped responsive-table"}
        columns={selectedColumns}
        data={passes.map(p => {
          return Object.assign({}, p, p.supplementary_data);
        })}
        style={style}
      />
    );
  }

  render() {
    let {
      isImporting,
      importCompleted,
      importSuccessful,
      importMessage,
      importOrder,
      previewData
    } = this.props
    let { currentImportStatus } = this.state
    let styles = this.getStyles()

    // const isMembership = this.props.location.pathname.includes("membership");
    const singular = this.state.isMembership ? "membership" : "pass"
    const plural = this.state.isMembership ? "memberships" : "passes"

    if (isImporting || (importCompleted && !previewData)) {
      return (
        <div style={styles.progressContainer}>
          {isImporting || (importOrder && !currentImportStatus.finished) ? (
            <CircularProgress size={1.5} mode="indeterminate" />
          ) : currentImportStatus.success ? (
            <CheckCircleIcon style={styles.icon} />
          ) : (
            <ErrorIcon style={styles.icon} />
          )}
          <div style={styles.message}>
            {isImporting ? (
              <div>
                {this.state.userReadyToImport ? "Importing" : "Previewing"}{" "}
                {plural}...
                <br />
                This may take a little while.
              </div>
            ) : (
              importMessage || this._makeImportMessage()
            )}
            &nbsp;
            {(importOrder && currentImportStatus.success) ||
              importSuccessful ? (
              <a
                style={styles.restartLink}
                onTouchTap={() =>
                  this.context.router.push(
                    `/orders${importOrder ? `/${importOrder}` : ""}`
                  )
                }
              >
                (view {importOrder ? "order" : "orders"})
              </a>
            ) : null}
            &nbsp;
            {!isImporting || currentImportStatus.finished ? (
              <a style={styles.restartLink} onTouchTap={this.reset}>
                (restart)
              </a>
            ) : null}
          </div>
        </div>
      );
    }

    if (previewData && this.state.selectedPassBucket) {
      return (
        <div>
          <p>
            We detected {previewData.passes.length} valid {formatBasedOnQuantity(previewData.passes.length, singular, plural)} in your uploaded
            data. Have a look:
          </p>
          {this._makeTable(this.state.selectedPassBucket, previewData.passes)}
          <p>
            Unless you choose not to send them, each individual in the above list will receive an email that in
            addition to instructions about logging in also contains the
            following content:
          </p>
          <div
            className="tenant-injected-html"
            style={styles.previewExtraMessage}
            dangerouslySetInnerHTML={{
              __html:
                this.state.extraMessage ||
                "<i>[No additional message will be attached]</i>"
            }}
          />
          {previewData.errors_encountered.length > 0 ? (
            <div>
              <p>We also detected {previewData.errors_encountered.length} {formatBasedOnQuantity(previewData.errors_encountered.length, "error", "errors")} in your uploaded data. You may continue with the import, but {formatBasedOnQuantity(previewData.errors_encountered.length, "this item", "these items")} will be processed as {formatBasedOnQuantity(previewData.errors_encountered.length, "an error", "errors")}:</p>
              {this._makeTable(this.state.selectedPassBucket, previewData.errors_encountered.map(error => ({ error: error.message, ...error.originalData })), {
                isErrorTable: true,
                style: {
                  marginTop: 16,
                }
              })}
              <FlatButton
                label="Download Error CSV"
                style={{ marginTop: 8, marginBottom: 16 }}
                onClick={this.onErrorCsvClick}
              />
            </div>
          ) : null}
          <p>
            If everything looks all right, confirm & start the import.
            Otherwise,{" "}
            <LinkLike onTouchTap={this.reset}>edit settings</LinkLike>.
          </p>
          <div>
            <Checkbox
              label={`Yes, I'm ready to import ${previewData.passes.length
                } valid ${formatBasedOnQuantity(previewData.passes.length, singular, plural)} ${previewData.will_email
                  ? "& send associated emails"
                  : "without sending any emails"
                }.`}
              checked={this.state.userReadyToImport}
              onCheck={() =>
                this.setState({
                  userReadyToImport: !this.state.userReadyToImport
                })
              }
            />
          </div>
          <div style={styles.actions}>
            <RaisedButton
              label="Start import"
              primary={true}
              disabled={!this.state.userReadyToImport}
              onTouchTap={this.import}
            />
          </div>
        </div>
      );
    }

    return (
      <div>
        <h1>Bulk import {plural}</h1>
        <InfoNotice style={{ marginTop: 20 }}>
          Check out our{" "}
          <a
            href={`${this.state.isMembership ? "https://help.eventive.org/en/articles/3116617-bulk-import-memberships-and-recurring-passes" : "https://help.eventive.org/passes/bulk-import-passes"}`}
            target="_blank"
          >
            guide to importing {plural}
          </a>
          .
        </InfoNotice>
        <p>
          Use this wizard to create {plural} in bulk. Just select a {singular} bucket,
          download the Excel template, fill in your data, and upload.
        </p>
        <p>
          If a user already has an account, the {singular} will be added to their
          existing account. If not, a new account will be generated. In either
          case, every user will receive an email notifying them about their new
          {singular}&mdash;you can use the "additional note" field to explain why
          they're receiving it.
        </p>
        <div>
          <InjectedSelect
            value={
              this.state.selectedPassBucket && this.state.selectedPassBucket.id
            }
            types={this.state.isMembership ? ["memberships"] : ["pass_buckets"]}
            label={this.state.isMembership ? "Memberships" : "Pass bucket"}
            labelFormatter={b => b.name}
            eventBucketId={this.props.params.eventBucketId}
            changeValueFunction={o => o}
            onChange={selected =>
              this.setState({ selectedPassBucket: selected })
            }
          />
        </div>
        <div style={styles.section}>
          <Label>
            Add spreadsheet (
            <a target="_blank" href={this.state.isMembership ? this._makeCsvLinkForMemberships() : this._makeCsvLink()}>
              download template
            </a>
            )
          </Label>
          <Dropzone
            style={styles.dropzone}
            multiple={false}
            onDrop={this.onDrop}
            accept={["text/csv", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]}
          >
            {({ isDragActive, isDragReject, acceptedFiles, rejectedFiles }) => {
              return isDragActive ? (
                "Release to select."
              ) : acceptedFiles.length ? (
                <span>
                  One spreadsheet <i>({acceptedFiles[0].name})</i> ready to
                  import.
                </span>
              ) : (
                "Drop spreadsheet here, or click to select."
              );
            }}
          </Dropzone>
        </div>
        <div style={styles.section}>
          <Label>Additional note (appended to notification email)</Label>
          <QuillEditor
            value={this.state.extraMessage}
            onChange={v => this.setState({ extraMessage: v })}
            basic={true}
          />
        </div>
        <div style={styles.section}>
          <Label style={{ marginBottom: 0 }}>Advanced options</Label>
          <LinkLike
            onTouchTap={() =>
              this.setState({ showAdvanced: !this.state.showAdvanced })
            }
          >
            {this.state.showAdvanced ? "Hide" : "Show"} advanced options
          </LinkLike>
          {this.state.showAdvanced ? (
            <div style={{ marginTop: 5 }}>
              <Checkbox
                label={
                  <span>
                    Do not send emails{" "}
                    <strong>
                      (Danger: importees will be unable to access their {plural} online!)
                    </strong>
                  </span>
                }
                checked={this.state.noEmail}
                onCheck={() => this.setState({ noEmail: !this.state.noEmail })}
              />
            </div>
          ) : null}
        </div>
        <div style={Object.assign({}, styles.actions, { marginTop: 20 })}>
          <RaisedButton
            label="Preview import..."
            primary={true}
            disabled={!(this.state.selectedPassBucket && this.state.csvFile)}
            onTouchTap={this.import}
          />
        </div>
      </div>
    );
  }
}

export default connectToStores(BulkImportPasses);



// WEBPACK FOOTER //
// ./src/app/components/bulk-import-passes.jsx